import { customAttribute } from 'aurelia-templating';
import { ThemeService } from '../../services/theme-service';
import { BindingEngine, Disposable } from 'aurelia-binding';

@customAttribute('theme-selector')
export class ThemeSelectorCustomAttribute {
  constructor(private element: Element, private themeService: ThemeService, private bindingEngine: BindingEngine) { }

  observer: Disposable;
  value: string;

  attached() {
    this.observer = this.bindingEngine.propertyObserverEx(this.themeService, 'darkTheme').subscribe(() => this.update());
    this.update();
  }

  update() {
    this.element.classList.toggle(`ag-theme-balham-dark${this.value ? `-${this.value}` : ''}`, this.themeService.darkTheme);
    this.element.classList.toggle(`ag-theme-balham${this.value ? `-${this.value}` : ''}`, !this.themeService.darkTheme);
  }

  detached() {
    this.observer?.dispose();
  }
}
